import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { t } from '../i18n';

export default function NotePageHeader({ title, description, onBack, backLabel = t('noteComposer.page.back') }) {
  return <header className="note-composer-header">
    <button type="button" className="composer-icon-button" onClick={onBack} aria-label={backLabel}>
      <ArrowLeft size={22} aria-hidden="true" />
    </button>
    <h1>{title}</h1>
    {description && <p>{description}</p>}
  </header>;
}
